const imgsArray = [
    require('./quran1.jpg'),
    require('./quran4.jpg'),
    // require('./quran5.jpg'),
    // require('./quran6.jpg'),
    require('./iqraa.png'),
    // Add more images as needed, following the pattern above
];

export default imgsArray;       